import { h, Component } from 'preact';
import { configure } from '../../config';
import style from './style';
import { Text, MarkupText, withText } from 'preact-i18n';
import { CcpaButtons } from '../ccpa-buttons';
import { Button } from '@cube/blocks';
import dlv from 'dlv';
import { trackEvent, INPUT_KEYS, DIMENSION, EVENT, INTERACTION } from '@cube/track';
import { getIsOptedOut, setOptOut } from '@cube/privacy-utils';

@withText({
	optInConfirmation: 'optInConfirmation',
	optInConfirmation20201123: '20201123.optInConfirmation'
})
export class CcpaMainWidget extends Component {

	state = {
		isOptedOut: null
	}

	buttonClicked = (partnerLink) => {
		if (partnerLink.external) {
			window.open(partnerLink.url, '_blank', 'noopener');
		}
		else {
			window.location.href = partnerLink.url;
		}
	}

	toggleOptOut = () => {
		const isOptedOut = getIsOptedOut();
		// if trying to opt in, get confirmation
		if (isOptedOut) {
			/* eslint-disable no-alert */
			let confirmed = confirm(this.props[`optInConfirmation${this.props.overrideVersion || ''}`] );
			if (!confirmed) {
				return;
			}
		}

		// toggle opt-out values
		setOptOut(!isOptedOut);
		// use the underlying `@cube/privacy-utils` as the source of truth for opt-out state
		this.setState({ isOptedOut: getIsOptedOut() });

		trackEvent( this.context, {
			[INPUT_KEYS.action]: EVENT.click,
			[DIMENSION.componentpath]: 'CcpaMain',
			[DIMENSION.interaction]: (isOptedOut ? INTERACTION.optin : INTERACTION.optout)
		});
	}

	componentWillMount() {
		const isOptedOut = getIsOptedOut();
		this.setState({ isOptedOut });
	}

	renderOriginalVersion({ buttonLinks, intlFields, isOptedOut }) {
		return (
			<div class={style.ccpa}>
				<div class={style.title}><Text id="mainTitle" /></div>
				<div class={style.description}><Text id="mainDescription" fields={intlFields} /></div>
				<div class={style.sectionTitle}><Text id="mainChoicesTitle" /></div>
				<div class={style.sectionDescription}><Text id="mainChoicesDescription1" fields={intlFields} /></div>
				<div class={style.sectionDescription}><Text id="mainChoicesDescription2" fields={intlFields} /></div>
				<div class={style.sectionDescription}>
					<Text id={`mainCurrently${isOptedOut ? '' : 'Not'}OptedOutStatus`} /> -<Button class={style.button} type="floating" onClick={this.toggleOptOut}><Text id={`opt${isOptedOut ? 'In' : 'Out'}`} /></Button>
				</div>
				<div class={style.sectionIndentedDescription}><Text id="mainCurrentlyOptedOutDescription" fields={intlFields} /></div>
				<div class={style.sectionIndentedDescription}><Text id="mainCurrentlyNotOptedOutDescription" fields={intlFields} /></div>
				<div class={style.sectionDescription}><Text id="mainChoicesDescription3" fields={intlFields} /></div>
				<div class={style.sectionIndentedDescription}><Text id="mainChoicesDescription4" fields={intlFields} /></div>
				<div class={style.sectionDescription}><MarkupText id="mainChoicesDescription5" fields={intlFields} /></div>
				<div class={style.sectionTitle}><Text id="mainDataAccessTitle" /></div>
				<div class={style.sectionDescription}><MarkupText id="mainDataAccessDescription" fields={intlFields} /></div>
				<div class={style.sectionTitle}><Text id="linksTitle" /></div>
				<CcpaButtons links={buttonLinks} />
			</div>
		);
	}

	render20201123Version({ buttonLinks, intlFields, isOptedOut, clientCCPALink }) {
		return (
			<div class={style.ccpa}>
				<div class={style.title}><Text id="20201123.mainTitle" /></div>
				<div class={style.description}><Text id="20201123.mainDescription" fields={intlFields} /><MarkupText id={`20201123.descriptionCoveredInteractionsWith${dlv(clientCCPALink, 'url') ? '' : 'out'}CCPAResource`} fields={intlFields} /></div>

				<div class={style.sectionTitle}><Text id="20201123.mainChoicesTitle" /></div>
				<div class={style.sectionDescription}><Text id="20201123.mainChoicesDescription1" fields={intlFields} /></div>
				<div class={style.sectionDescription}><Text id="20201123.mainChoicesDescription2" fields={intlFields} /></div>
				<div class={style.sectionDescription}>
					<Text id={`20201123.mainCurrently${isOptedOut ? '' : 'Not'}OptedOutStatus`} /> -<Button class={style.button} type="floating" onClick={this.toggleOptOut}><Text id={`opt${isOptedOut ? 'In' : 'Out'}`} /></Button>
				</div>
				<div class={style.sectionIndentedDescription}><Text id="20201123.mainCurrentlyOptedOutDescription" fields={intlFields} /></div>
				<div class={style.sectionIndentedDescription}><Text id="20201123.mainCurrentlyNotOptedOutDescription" fields={intlFields} /></div>
				<div class={style.sectionDescription}><Text id="20201123.mainChoicesDescription3" fields={intlFields} /></div>
				<div class={style.sectionIndentedDescription}><Text id="20201123.mainChoicesDescription4" fields={intlFields} /></div>
				<div class={style.sectionDescription}><MarkupText id="20201123.mainChoicesDescription5" fields={intlFields} /></div>

				<div>
					<div class={style.sectionTitle}><Text id="20201123.mainCollectionAndUseTitle" /></div>
					<div class={style.sectionDescription}><Text id="20201123.mainCollectionAndUseDescription1" fields={intlFields} /></div>
					<div class={style.sectionDescription}><Text id="20201123.mainCollectionAndUseDescription2" fields={intlFields} /></div>
					<ul>
						<li><Text id="20201123.mainCollectionAndUseDescription3" fields={intlFields} /></li>
						<li><Text id="20201123.mainCollectionAndUseDescription4" fields={intlFields} /></li>
					</ul>
					<div class={style.sectionDescription}><MarkupText id="20201123.mainCollectionAndUseDescription5" fields={intlFields} /></div>
				</div>

				<div class={style.sectionTitle}><Text id="20201123.mainDataAccessTitle" /></div>
				<div class={style.sectionDescription}><MarkupText id="20201123.mainDataAccessDescription" fields={intlFields} /></div>

				<div class={style.sectionTitle}><Text id="20201123.linksTitle" /></div>
				<CcpaButtons links={buttonLinks} />
			</div>
		);
	}

	render({ clientDisplayName, links, clientCCPALink, overrideVersion }, { isOptedOut }) {
		let buttonLinks = [links.data, links.partners, links.privacy],
			hostname = window.location.hostname;

		let intlFields = { clientDisplayName, hostname, ccpaLinks: { ...links, clientCCPA: clientCCPALink } };

		return overrideVersion === '20201123' ?
			this.render20201123Version({ buttonLinks, intlFields, isOptedOut, clientCCPALink }) :
			this.renderOriginalVersion({ buttonLinks, intlFields, isOptedOut });
	}
}

export const CcpaMain = (configure({
	overrideVersion: 'privacyWidgetsConfig.overrideVersion',
	links: 'privacyWidgetsConfig.ccpa.links',
	clientCCPALink: 'privacyWidgetsConfig.ccpa.links.clientCCPA', //break out separately for easier toggling/mocking of it in DEMO
	clientDisplayName: 'clientDisplayName'
})((props) =>  (
	<CcpaMainWidget {...props} />
)));
